// eslint-disable-next-line no-shadow
export enum FeatureFlag {
  dbd477 = 'dbd477',
  dpd794 = 'dpd794',
  dbd880 = 'dbd880',
  dbd921 = 'dbd921',
  enableCreatePlanButton = 'enableCreatePlanButton',
  dpd1338 = 'dpd1338',
  dbd1176 = 'dbd1176',
  dbd2341OnboardingMorrisonsLive = 'dbd2341OnboardingMorrisonsLive',
  lpad313ShowAutomatedCampaigns = 'lpad313ShowAutomatedCampaigns',
  dbd3882 = 'dbd3882',
  dbd4227ToggleContentLinkCampaigns = 'dbd4227ToggleContentLinkCampaigns',
}
